import { render, staticRenderFns } from "./_SelfDestructDialog.vue?vue&type=template&id=2ebaf821&scoped=true&"
import script from "./_SelfDestructDialog.vue?vue&type=script&lang=ts&"
export * from "./_SelfDestructDialog.vue?vue&type=script&lang=ts&"
import style0 from "./_SelfDestructDialog.vue?vue&type=style&index=0&id=2ebaf821&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaf821",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCardActions,VCardText,VCol,VDivider,VIcon,VRow,VSlideXReverseTransition,VSlideYReverseTransition,VSpacer})
